import React, { Component } from 'react'
import './Table.scss'
import TableHeader from './TableHeader'
import TableData from './TableData'
import { Table as TableComponent } from 'react-bootstrap'

class Table extends Component {

    constructor(props) {
        super(props)
        this.properties = { ...this.props }
        delete this.properties['headers']
        delete this.properties['data']

    }

    render() {
        return (
            <TableComponent {...this.properties}>
                {this.props.caption && <caption>{this.props.caption}</caption>}
                {this.props.headers && <TableHeader data={this.props.headers} />}
                {this.props.data && <TableData data={this.props.data} keysToSelect={this.props.keysToSelect} />}
            </TableComponent>
        )
    }
}

export default Table